import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";

import rootReducer from "./reducers";
import storage from "redux-persist/lib/storage";

import { composeWithDevTools } from "redux-devtools-extension";
import { createBrowserHistory } from "history";
import thunk from "redux-thunk";
import { persistReducer } from "redux-persist";
import { routerMiddleware } from "connected-react-router";
import logger from "redux-logger";

import rootSaga from "./sagas";

const sagaMiddleware = createSagaMiddleware();
export const history = createBrowserHistory();

//Blacklist AssetTypes on Page Refresh
const persistConfig = {
  key: "b2c",
  storage,
  blacklist: ["router", "AssetTypes", "Accessories", "MeterReports", "MetersRegistration"],
};

const initialState = {};
const middleware = [routerMiddleware(history), sagaMiddleware, thunk, logger];
const persistedReducer = persistReducer(persistConfig, rootReducer(history));

const store = createStore(persistedReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));

sagaMiddleware.run(rootSaga);

export default store;
